import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import {store2} from "./redux/store2";
import axios from "axios";
import { logout } from "./redux/slices/userSlice";

// 401 = the token expired or is invalid: end the session (back to login)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && store2.getState().auth?.isLoggedIn) {
      store2.dispatch(logout());
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store2}>
    <App />
  </Provider>
);
